import * as  LinkifyIt from "linkify-it";
import { LayoutToolbarHeight } from "assets/jss/common-styles";

export default class HtmlUtils {

    static isLocalhost(): boolean {
        return window.location.hostname == "localhost"
            || window.location.hostname.indexOf("10.") > -1
            || window.location.hostname.indexOf("127.") > -1
            || window.location.hostname.indexOf("192.") > -1
            || window.location.hostname.indexOf("172.16.") > -1
            ;
    }

    static getDomain(url: string): string {
        return url ? (url.split('/')[2] || url.split('/')[0]).split(':')[0] : url;
    }

    static getFullLocation(): string {
        return window.location.protocol
            + "//"
            + window.location.hostname
            + (window.location.port ? ":" + window.location.port : "");
    }

    static getFullUrl(url: string): string {
        return this.getFullLocation() + url;
    }

    static openUrlInNewWindow(
        url: string,
        windowName?: string,
        features?: {
            noopener?: boolean;
            noreferrer?: boolean;
            forceNewWindow?: boolean;
        }
    ): Window {

        if (window.opener && features?.forceNewWindow !== true) {

            // Se já está em uma página secundária,
            // mantém a URL na mesma página se for algum 'viewer'.
            var aux = document.location.pathname.toLowerCase().split('/');
            if (aux.length > 3 && aux[2].endsWith('viewer')) {
                document.location.href = url;
                return window;
            }
        }

        var f: Array<string> = [];
        if (features?.noopener == true) f.push("noopener");
        if (features?.noreferrer == true) f.push("noreferrer");

        return window.open(this.getFullUrl(url), windowName, f.join(","));
    }

    static closeWindow(window: Window): void {
        return window.close();
    }

    static download(url: string, filename?: string): void {
        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", filename || (new Date().getTime().toString()));
        var b = document.createEvent("MouseEvents");
        b.initEvent("click", false, true);
        a.dispatchEvent(b);
    }

    static isHtml(str: string): boolean {
        return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(str);
    }

    static escape(str: string): string {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    static linkifyContent(content: string): string {
        const linkify = new LinkifyIt();

        var out = HtmlUtils.escape(content),
            matches = linkify.match(content),
            result = [] as any,
            last: any;

        if (matches) {
            last = 0;
            matches.forEach(function (match) {
                if (last < match.index) {
                    result.push(HtmlUtils.escape(content.slice(last, match.index)).replace(/\r?\n/g, '<br>'));
                }
                result.push('<a target="_blank" href="');
                result.push(HtmlUtils.escape(match.url));
                result.push('">');
                result.push(HtmlUtils.escape(match.text));
                result.push('</a>');
                last = match.lastIndex;
            });
            if (last < content.length) {
                result.push(HtmlUtils.escape(content.slice(last)).replace(/\r?\n/g, '<br>'));
            }
            out = result.join('');
        }

        return out;
    }

    static containOneLinkOnly(content: string): boolean {
        const linkify = new LinkifyIt();

        var out = content.replace(/\r?\n/g, ''),
            matches = linkify.match(content);

        if (matches) {
            matches.forEach(function (match) {
                out = out.replace(match.raw, "");
            });
        }

        return out.length == 0;
    }


    static validateHtml(htmlStr: string, strictBoolean: boolean): boolean | string {
        if (typeof htmlStr !== "string")
            return false;

        var validateHtmlTag = new RegExp("<[a-z]+(\s+|\"[^\"]*\"\s?|'[^']*'\s?|[^'\">])*>", "igm"),
            sdom = document.createElement('div'),
            noSrcNoAmpHtmlStr = htmlStr
                .replace(/ src=/, " svhs___src=") // disarm src attributes
                .replace(/&amp;/igm, "#svhs#amp##"), // 'save' encoded ampersands
            noSrcNoAmpIgnoreScriptContentHtmlStr = noSrcNoAmpHtmlStr
                .replace(/\n\r?/igm, "#svhs#nl##") // temporarily remove line breaks
                .replace(/(<script[^>]*>)(.*?)(<\/script>)/igm, "$1$3") // ignore script contents
                .replace(/#svhs#nl##/igm, "\n\r"),  // re-add line breaks
            htmlTags = noSrcNoAmpIgnoreScriptContentHtmlStr.match(/<[a-z]+[^>]*>/igm), // get all start-tags
            htmlTagsCount = htmlTags ? htmlTags.length : 0,
            tagsAreValid, resHtmlStr;


        if (!strictBoolean) {
            // ignore <br/> conversions
            noSrcNoAmpHtmlStr = noSrcNoAmpHtmlStr.replace(/<br\s*\/>/, "<br>");
        }

        if (htmlTagsCount) {
            tagsAreValid = htmlTags.reduce((isValid: any, tagStr: any) => {
                return isValid && tagStr.match(validateHtmlTag);
            }, true);

            if (!tagsAreValid) {
                return false;
            }
        }

        try {
            sdom.innerHTML = noSrcNoAmpHtmlStr;
        } catch (err) {
            return false;
        }

        // compare rendered tag-count with expected tag-count
        if (sdom.querySelectorAll("*").length !== htmlTagsCount) {
            return false;
        }

        resHtmlStr = sdom.innerHTML.replace(/&amp;/igm, "&"); // undo '&' encoding

        if (!strictBoolean) {
            // ignore empty attribute normalizations
            resHtmlStr = resHtmlStr.replace(/=""/, "");
        }

        // compare html strings while ignoring case, quote-changes, trailing spaces
        var
            simpleIn = noSrcNoAmpHtmlStr.replace(/["']/igm, "").replace(/\s+/igm, " ").toLowerCase().trim(),
            simpleOut = resHtmlStr.replace(/["']/igm, "").replace(/\s+/igm, " ").toLowerCase().trim();
        if (simpleIn === simpleOut)
            return true;

        return resHtmlStr.replace(/ svhs___src=/igm, " src=").replace(/#svhs#amp##/, "&amp;");
    }


    static checkMouseInsideHtmlElement(element: HTMLElement, m: MouseEvent): boolean {
        const dropdown = element.getBoundingClientRect();
        const target = { y: m.clientY, x: m.clientX };
        return target.y >= dropdown.top && target.y <= dropdown.bottom && target.x >= dropdown.left && target.x <= dropdown.right;
    }


    static textToHtml(text: string): string {
        if (text) {
            return text.replace(/\n/g, "<br/>");
        }
        return text;
    }


    static scrollToElement(id: string): void {
        const ele = document.getElementById(id);
        const yCoordinate = ele.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -LayoutToolbarHeight;

        window.scrollTo({
            top: yCoordinate + yOffset,
            behavior: 'smooth'
        });
    }

    static screenDimension() {
        var x, y;
        if (window.innerWidth) {
            x = window.innerWidth;
            y = window.innerHeight;
        } else {
            x = document.body.clientWidth;
            y = document.body.clientHeight;
        }

        return { width: x, height: y };
    }

    static isIPad(): boolean {
        const m = navigator.platform.match(/iPad/i);
        return m != null && m.length > 0;
    }
}

export type ScreenPoint = { x: number; y: number; };
